import React, { createContext, useContext, useState } from 'react';

const RegistrationContext = createContext();

export const useRegistration = () => {
  const context = useContext(RegistrationContext);
  if (!context) {
    return {
      registrationStep: 1,
      setRegistrationStep: () => { } // Defensive no-op to prevent runtime errors
    };
  }
  return context;
};

export const RegistrationProvider = ({ children }) => {
  const [registrationStep, setRegistrationStep] = useState(1);
  const [registrationData, setRegistrationData] = useState({});

  const updateRegistrationData = (data) => {
    setRegistrationData(prev => ({ ...prev, ...data }));
  };

  const resetRegistration = () => {
    setRegistrationStep(1);
    setRegistrationData({});
  };

  return (
    <RegistrationContext.Provider value={{
      registrationStep,
      setRegistrationStep,
      registrationData,
      setRegistrationData,
      updateRegistrationData,
      resetRegistration
    }}>
      {children}
    </RegistrationContext.Provider>
  );
};
